import TableForm from './table_form.vue';

export default TableForm;
